import React from 'react';
import ReactDOM from 'react-dom/client';
import '../styles/index.css';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { Capacitor } from '@capacitor/core';
import { msalInstance } from '@/lib/auth/msalConfig';
import {
  initializeSfmcSdk,
  registerPushNotificationsIfConsented,
} from '@/lib/notifications/pushNotifications';
import App from './app';

msalInstance.initialize().then(async () => {
  // On native, auth is handled via implicit flow — no redirect to process here.
  if (!Capacitor.isNativePlatform()) {
    await msalInstance.handleRedirectPromise({ navigateToLoginRequestUrl: false }).catch(() => undefined);
  }

  // Both platforms now init the SFMC SDK natively at app startup (Android's Application.onCreate,
  // iOS's AppDelegate.didFinishLaunchingWithOptions) — this call is just a readiness no-op on
  // both. Failure is swallowed internally — it must never block app startup.
  await initializeSfmcSdk();
  // Re-enables push for returning users who consented in a past session (enablePush() itself
  // is otherwise only triggered by a fresh "Allow Notifications" grant — see
  // requestPushNotificationPermission()). Failure is swallowed internally.
  await registerPushNotificationsIfConsented();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>
  );
});
